import PropTypes from "prop-types";
import ModalBox from "@/components/core/ModalBox";
import { Button } from "@/components/core/form";

const AutoDebitModal = ({
  show,
  onClose,
  title,
  message,
  confirmText,
  widthClass,
  disableBackdropClose,
  className,
}) => {
  return (
    <ModalBox
      show={show}
      toggle={onClose}
      size="md"
      className={className || "rPremiumBreakupModal"}
      onModalDismiss={() => {
        if (!disableBackdropClose) onClose?.();
      }}
    >
      <div className="row mAlignCenter">
        <div className="col-md-12 text-center">
          {title ? <div className="boldContentClass5">{title}</div> : null}
          {message ? <div className="mt-2">{message}</div> : null}
        </div>
      </div>

      <div className="row d-flex justify-content-center mt-3">
        <Button
          type="button"
          className={`btn rounded-pill m-0 ${widthClass || "w-25"}`}
          secondary={false}
          active={true}
          bottomFixed={false}
          onClick={onClose}
          aria-label={confirmText}
        >
          {confirmText}
        </Button>
      </div>
    </ModalBox>
  );
};

AutoDebitModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmText: PropTypes.string,
  widthClass: PropTypes.string,
  disableBackdropClose: PropTypes.bool,
  className: PropTypes.string,
};

AutoDebitModal.defaultProps = {
  title: "Notice",
  message: "",
  confirmText: "OK",
  widthClass: "w-25",
  disableBackdropClose: false,
  className: "rPremiumBreakupModal",
};

export default AutoDebitModal;
